import { useContext, useEffect } from 'react';

import { findAndMatchRoute } from '@confluence/route-manager/entry-points/RouteManager';
import {
	namedRoutes,
	BASE,
	WIKI,
	HOME,
	ALL_UPDATES,
	DASHBOARD_ACTION_LEGACY,
} from '@confluence/named-routes';
import { ExperienceTrackerContext, startExperienceForRoute } from '@confluence/experience-tracker';

const routeNamesThatRedirectToHome = [
	BASE.name,
	WIKI.name,
	ALL_UPDATES.name,
	DASHBOARD_ACTION_LEGACY.name,
];

export const useExperienceFailureForRoute = (url: string, entryPoint?: string) => {
	const experienceTracker = useContext(ExperienceTrackerContext);

	useEffect(() => {
		let routeMatch = findAndMatchRoute(namedRoutes, url);

		// If the route redirects to /home, convert the URL to a HOME URL
		if (!!routeMatch?.name && routeNamesThatRedirectToHome.includes(routeMatch?.name)) {
			const routeQuery = routeMatch?.query;
			const routeHash = routeMatch?.hash;
			const homeUrl = HOME.toUrl(undefined, { query: routeQuery, hash: routeHash });
			routeMatch = findAndMatchRoute(namedRoutes, homeUrl);
		}

		if (routeMatch) {
			startExperienceForRoute(routeMatch, 0);
			experienceTracker.fail({
				error: new Error('FATAL ERROR: Error SPA rendered'),
				attributes: {
					entryPoint: entryPoint ?? "unknown",
				},
			});
		}
	}, [experienceTracker, url]);
};
